import { render, staticRenderFns } from "./createSupportPackage.vue?vue&type=template&id=52d1d2f2"
import script from "./createSupportPackage.vue?vue&type=script&lang=js"
export * from "./createSupportPackage.vue?vue&type=script&lang=js"
import style0 from "./createSupportPackage.vue?vue&type=style&index=0&id=52d1d2f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports